<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar
        class="navbar-custom navbar-skelton"
        :class="navbarClasses"
        :style="navbarStyle"
        :color="navbarColor"
      >
        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

        <router-link
          tag="div"
          to="/"
          class="vx-logo cursor-pointer mx-auto flex items-center"
        >
          <logo class="w-12 mr-6 fill-current text-primary" />
          <!-- <vx-tooltip position="bottom"> -->
          <span class="vx-logo-text text-primary">Firewood ERP</span>
          <!-- </vx-tooltip> -->
        </router-link>

        <!-- <i18n /> -->

        <feather-icon
          @click="toggleTheme"
          :icon="isThemedark === 'dark' ? 'SunIcon' : 'MoonIcon'"
          svgClasses="cursor-pointer navbar-fuzzy-search ml-4"
        />

        <search-bar />

        <notification-drop-down class="ml-4" />

        <profile-drop-down />

        <div v-if="window" class="vx-row ml-4 mr-4">
          <vx-tooltip position="bottom" text="Minimize">
            <feather-icon
              @click="window.minimize()"
              class="ml-2 mt-2 mr-1 hover:text-primary"
              icon="MinusIcon"
              :svgClasses="['h-5 w-5 stroke-current', textColor]"
            ></feather-icon>
          </vx-tooltip>
          <vx-tooltip position="bottom" text="Close">
            <feather-icon
              @click="closeApp"
              class="ml-2 mt-2 mr-1 hover:text-danger"
              icon="XIcon"
              :svgClasses="['h-5 w-5 stroke-current', textColor]"
            ></feather-icon>
          </vx-tooltip>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import I18n from "./components/I18n.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import Logo from "../Logo.vue";

export default {
  name: "the-navbar-horizontal",
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true,
    },
  },
  components: {
    Logo,
    Bookmarks,
    I18n,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
  },
  data() {
    return {
      app: window.require,
    };
  },
  methods: {
    closeApp() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Close Express POS",
        text:
          "You are about to close Express POS. Any unsaved data would be lost. Are you sure you want to proceed?",
        accept: () => {
          this.window.close();
        },
      });
    },
    toggleTheme() {
      this.$store.dispatch(
        "updateTheme",
        this.isThemedark === "dark" ? "light" : "dark"
      );
    },
  },
  computed: {
    window() {
      if (this.app) {
        const remote = window.require("electron").remote;
        return remote.getCurrentWindow();
      }
    },
    textColor() {
      return {
        "text-white":
          this.$store.state.mainLayoutType === "vertical" &&
          this.navbarColor !=
            (this.$store.state.theme === "dark" ? "#10163a" : "#fff"),
      };
    },
    navbarColor() {
      let color = "#fff";
      if (this.navbarType === "sticky") color = "#f7f7f7";
      else if (this.navbarType === "static") {
        if (this.scrollY < 50) {
          color = "#f7f7f7";
        }
      }

      this.isThemedark === "dark"
        ? color === "#fff"
          ? (color = "#10163a")
          : (color = "#262c49")
        : null;

      return color;
    },
    isThemedark() {
      return this.$store.state.theme;
    },
    navbarStyle() {
      return this.navbarType === "static"
        ? { transition: "all .25s ease-in-out" }
        : {};
    },
    navbarClasses() {
      return this.scrollY > 5 && this.navbarType === "static"
        ? null
        : "d-theme-dark-light-bg shadow-none";
    },
    scrollY() {
      return this.$store.state.scrollY;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
};
</script>
